import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cookie-consent',

  templateUrl: './cookie-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent implements OnInit {
  public showBanner = false;

  ngOnInit(): void {
    if (typeof localStorage !== 'undefined') {
      const cookieConsent = localStorage.getItem('cookieConsent');
      if (cookieConsent !== 'true') {
        this.showBanner = true;
      }
    }
  }

  acceptCookies(): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('cookieConsent', 'true');
      this.showBanner = false;
    }
  }
}
